import { observable, action, runInAction, decorate } from "mobx";
import CustomersAdditionalFieldsApi from "./api";

class CustomersAdditionalFieldsStore {
    rootStore;
    apiClient;

    list = [];
    total = 0;
    customerId = undefined;

    isFetchingListInProgress = false;
    fetchingListError = undefined;

    isAddingInProgress = false;
    addingError = undefined;

    isDeletingInProgress = false;
    deletingError = undefined;

    constructor(rootStore) {
        this.rootStore = rootStore;
        this.apiClient = new CustomersAdditionalFieldsApi(rootStore.apiClient);
    }

    async fetchList(customerId) {
        runInAction(() => {
            this.customerId = customerId;
            this.isFetchingListInProgress = true;
            this.fetchingListError = undefined;
        });
        try {
            const data = await this.apiClient.list(customerId, 1, 1000);
            runInAction(() => {
                this.list = (data && data.items) || [];
                this.total = (data && data.total_count) || 0;
                this.isFetchingListInProgress = false;
            });
        } catch (err) {
            runInAction(() => {
                this.list = [];
                this.total = 0;
                this.fetchingListError = err;
                this.isFetchingListInProgress = false;
            });
        }
    }

    async addRecord(customerId, record) {
        runInAction(() => {
            this.isAddingInProgress = true;
            this.addingError = undefined;
        });
        try {
            const data = await this.apiClient.add(customerId, record);
            await this.fetchList(customerId);
            runInAction(() => {
                this.isAddingInProgress = false;
            });
            return data;
        } catch (err) {
            runInAction(() => {
                this.addingError = err;
                this.isAddingInProgress = false;
            });
        }
    }

    async updateRecord(customerId, id, record) {
        runInAction(() => {
            this.isAddingInProgress = true;
            this.addingError = undefined;
        });
        try {
            const data = await this.apiClient.update(customerId, id, record);
            await this.fetchList(customerId);
            runInAction(() => {
                this.isAddingInProgress = false;
            });
            return data;
        } catch (err) {
            runInAction(() => {
                this.addingError = err;
                this.isAddingInProgress = false;
            });
        }
    }

    async deleteRecord(customerId, id) {
        runInAction(() => {
            this.isDeletingInProgress = true;
            this.deletingError = undefined;
        });
        try {
            const data = await this.apiClient.delete(customerId, id);
            await this.fetchList(customerId);
            runInAction(() => {
                this.isDeletingInProgress = false;
            });
            return data;
        } catch (err) {
            runInAction(() => {
                this.deletingError = err;
                this.isDeletingInProgress = false;
            });
        }
    }

    reset() {
        runInAction(() => {
            this.list = [];
            this.total = 0;
            this.customerId = undefined;
        });
    }
}

decorate(CustomersAdditionalFieldsStore, {
    list: observable,
    total: observable,
    customerId: observable,
    isFetchingListInProgress: observable,
    fetchingListError: observable,
    isAddingInProgress: observable,
    addingError: observable,
    isDeletingInProgress: observable,
    deletingError: observable,
    fetchList: action,
    addRecord: action,
    updateRecord: action,
    deleteRecord: action,
    reset: action,
});

export default CustomersAdditionalFieldsStore;
